module.exports = __webpack_public_path__ + "img/coquillages-en-ligne-boutrais.3bf000ec.png";